module.exports = __webpack_public_path__ + "static/img/pic-bg-active-4.0942e3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/pic-bg-active-4.png
// module id = ngjl
// module chunks = 0